import { createSelector } from '@ngrx/store';

import * as fromFeature from '../reducers';
import * as fromFeaturedEvents from '../reducers/featured-events.reducer';

export const getFeaturedEventsState = createSelector(fromFeature.getEventState, (state: fromFeature.EventState) => state.featuredEvents);

export const getFeaturedEventsEntities = createSelector(getFeaturedEventsState, fromFeaturedEvents.getFeaturedEventsEntities);

export const getAllFeaturedEvents = createSelector(getFeaturedEventsEntities, entities => {
  return Object.keys(entities).map(id => entities[+id]);
});

export const getFeaturedEventsLoading = createSelector(getFeaturedEventsState, fromFeaturedEvents.getFeaturedEventsLoading);
export const getFeaturedEventsLoaded = createSelector(getFeaturedEventsState, fromFeaturedEvents.getFeaturedEventsLoaded);
export const getFeaturedEventsError = createSelector(getFeaturedEventsState, fromFeaturedEvents.getFeaturedEventsError);
